import React, { Component, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import 'less/dashboard.less'
import ProjectSidebar from 'containers/dashboard/sidebar'
import EditSampleSizeModal from 'containers/dashboard/edit-sample-size-modal'
import GenerateSchedulerLinkModal from 'containers/dashboard/generate-scheduler-link-modal'
import GenerateSchedulerLinkConfirmationModal from 'containers/dashboard/generate-scheduler-link-confirmation-modal'
import EditSurveyIdModal from 'containers/dashboard/edit-survey-id-modal'
import EditInterviewOrModeratorBufferModal from 'containers/dashboard/edit-interview-or-moderator-buffer-modal'
import ConfirmEditSurveyIdModal from 'containers/dashboard/confirm-edit-survey-id-modal'
import EditSampleSizeWarningModal from 'containers/dashboard/edit-sample-szie-warning-modal'
import { pathOr, pipe, propEq } from 'ramda'
import { Dialog } from '@blueprintjs/core'
import { ModalFooterControls } from 'shared/helpers/modal-controls'
import CrowdProgressBar from 'shared/helpers/crowd-progress'
import ConferenceLink from './conference-link'
import TopicName from './topic-name'
import { launchSurveys, closeSurveys } from 'store/sidebar/sidebarActions'
import { localizedTranslate } from 'assets/localization'
import {
  fetchProjectSurveys, 
  generateSchedulerLink,
  editSurveyId,
  getAvModeratorsCount,
  updateProjectSampleSize,
  editInterviewBuffer,
} from 'store/project/projectActions'
import { axiosInstance } from 'network/apis'
import { getEmailTemplate } from 'store/editSession/editSessionActions'
import Button from 'components/controls/button'
import { getUserTimeZone} from 'assets/localization'
import { timezoneAbbreviationLabel } from 'shared/helpers/user'
import SectionHeader from 'components/section-header'


const completesWarning = `
You are requesting more completes than you have defined moderator availability; your survey might not close on its own.
Are you sure you want to launch this survey?
`
const closeWarning = `Are you sure you want to pause this
project?

This will pause all screeners and allow
you to make changes.
`

const CompletionsModal = props =>
  <Dialog
    iconName="calendar"
    isOpen={props.open}
    title="Warning"
  >
    <div className="bp3-dialog-body">
      {completesWarning}
    </div>
    <div className="bp3-dialog-footer">
      <ModalFooterControls
        toggleModal={props.closeModal}
        finalStep
        finalStepFn={pipe(props.closeModal, props.launch)}
        finalStepLabel="Launch Anyway"
      />
    </div>
  </Dialog>

const CloseWarningModal = props =>
  <Dialog
    className="close-recruiter-modal"
    onClose={props.closeModal}
    isOpen={props.open}
  >
    <div className="bp3-dialog-body close-survey-dialog-body">
      <div className="close-dialog-icon" />
      <div className="close-dialog-text">{closeWarning}</div>
    </div>
    <div className="bp3-dialog-footer">
      <ModalFooterControls
        toggleModal={props.closeModal}
        finalStep
        finalStepFn={pipe(props.closeModal, props.closeSurveys)}
        finalStepLabel="Pause & Edit"
      />
    </div>
  </Dialog>

const ScheduleButton = ({ projectId, requested, scheduled, completed, history, showSnackbarMessageError, hideSnackbarMessage, setFilterdProjects, projectList, clientId, userTimeZone, timezoneAbbreviationLabel }) => {
  const [link, setLink] = useState("")

  const list = projectList[clientId] ? projectList[clientId] : []
  const projectListSet = new Set
  Object.entries(list).map(item => {
    if (item[clientId].id !== projectId) projectListSet.add(item[clientId].id)
  })

  const getLink = async () => {
      try{
        const res = await axiosInstance.post(`project/${projectId}/handle-export`,{ pmTimeZone: userTimeZone, pmTimeZoneAbbr: timezoneAbbreviationLabel } ,{ handlerEnabled: true })
        return res
      } catch(e){
        console.log("There is an error in downloading the schedule", e)
      }
    }
  const handleDownload = (url, e) => {
    if (!url){
      e.preventDefault()
      showSnackbarMessageError("An error occured when downloading the schedule")
      hideSnackbarMessage()
    } 
  }
    useEffect (() => {
        try {       
          getLink().then(res => {
            if (res){
              setLink(res.data.fileURL)
            }
          })
      } catch (e) {
        console.log("There is an error in downloading the schedule", e)
      }
    }, [])
  const hasSchedule = Boolean(scheduled || completed)
  return (<div className="screener-container">
    <div className="header">
      <span className="header-text">
        <span className="header-title">Schedule</span>
        <span className="header-divider"></span>
        <span className="header-subtitle">| View and manage availability and scheduled interviews. </span>
      </span>
    </div>
    <div
      className={`dashboard-button schedule-button ${hasSchedule ? '' : 'empty-schedule'}`}
    >
      <div className="schedule-info">
        <div className="manage-schedule">
          <i className="im-calendar" /><span>Schedule Overview</span>
        </div>
        <CrowdProgressBar
          className="interview-info"
          requested={requested}
          scheduled={scheduled}
          completed={completed}
        />
      </div>
      <React.Fragment>
        <Button className="view-calendar-btn btn-primary"
          onClick={() => {
            projectListSet && setFilterdProjects (projectListSet)
            history.push(`/moderator/schedule`)
          }}>
          View Project Schedule
          <i className='im-calendar' />
        </Button>
      </React.Fragment>
      {hasSchedule && (
        <React.Fragment>
          <div className="line" />
          <div className="schedule-actions">
            <a onClick={(e) => handleDownload(link, e) }
              className="download-schedule"
              href={link}
              download={link ? true : false}
              rel="noopener noreferrer"
            ><i className="im-ss-downloadcloud" /> Download Schedule </a>
          </div>
        </React.Fragment>
      )}
    </div>
  </div>)
}

class Dashboard extends Component {

  handleTabChange = (selectedTab) => this.props.handleTabChange({selectedTab})

  initLaunchInactiveSurveys = () => this.props.initLaunchSurveys(this.props.inactiveSurveys)
  initCloseActiveSurveys = () => this.props.initCloseSurveys(this.props.activeSurveys)

  launchSurveys = () => this.props.launchSurveys(this.props.surveysToLaunch)
  closeSurveys = () => this.props.closeSurveys(this.props.surveysToClose)

  render () {
    return (
      <div className="project-dashboard-container">
        <div className="main-content">
          <ScheduleButton
            projectId={this.props.currentProject.id}
            history={this.props.history}
            requested= {this.props.currentProject.sampleSize} 
            scheduled= {pathOr(0, ['currentProject', 'scheduled'], this.props)}
            completed= {pathOr(0, ['currentProject', 'completed'], this.props)}
            showSnackbarMessageError = {this.props.showSnackbarMessageError}
            hideSnackbarMessage = {this.props.hideSnackbarMessage}
            setFilterdProjects = {this.props.setFilterdProjects}
            projectList = {this.props.projectList}
            clientId = {this.props.clientId}
            userTimeZone={this.props.userTimeZone}
            timezoneAbbreviationLabel = { timezoneAbbreviationLabel(this.props.userTimeZone) }
          /> 
          <div>
          <div>
            <div className="topic-name-container">
                <SectionHeader
                  header={this.props.t('topic.name.title')}
                  subHeader={this.props.t('topic.name.description')}
                ></SectionHeader>
              <TopicName
                currentProject={this.props.currentProject}
                t={this.props.t}
              />
            </div>
          </div>
            {/* {surveyTypes.map(({surveys}, i) => hasLength(surveys) && */}
              <div className="screener-container survey-container">
              <SectionHeader
                header={this.props.t('conference.link.title')}
                subHeader={this.props.t('conference.link.subHeader')}
              ></SectionHeader>
                  {/* {surveys.map(survey => */}
                  <ConferenceLink
                    currentProject={this.props.currentProject}
                    showSnackbarMessage={this.props.showSnackbarMessage}
                    hideSnackbarMessage={this.props.hideSnackbarMessage}
                    t={this.props.t}
                    exampleEmail = {this.props.exampleEmail} 
                    templateReceived = {this.props.templateReceived} 
                    getEmailTemplate = {this.props.getEmailTemplate}
                    closeTemplate = {this.props.closeTemplate}
                    setChosenTranslationsLabels = {this.props.setChosenTranslationsLabels}
                  />
              </div>
            {/* )} */}
          </div>
        </div>
        <div className="side-content">
          <ProjectSidebar 
          {...this.props}
          />
        </div>
        <CompletionsModal
          match={this.props.match}
          closeModal={this.props.toggleCompletionsWarning}
          open={this.props.completionsWarningOpen}
        />
        <CloseWarningModal
          match={this.props.match}
          surveysToClose={this.props.surveysToClose}
          closeModal={this.props.toggleCloseWarning}
          open={this.props.closeWarningOpen}
          closeSurveys={this.closeSurveys}
        />
        {this.props.editSampleSizeModal.isOpen && <EditSampleSizeModal
          isOpen={this.props.editSampleSizeModal.isOpen}
          onClose={this.props.closeEditSampleSizeModal}
          projectId={this.props.editSampleSizeModal.projectId}
          initialSampleSize={this.props.editSampleSizeModal.initialSampleSize}
          sampleSize= {this.props.editSampleSizeModal.sampleSize}
          completed={this.props.currentProject.completed}
          scheduled={this.props.currentProject.scheduled}
          showWarning={this.props.editSampleSizeModal.showWarning}
          avModCount={this.props.editSampleSizeModal.avModCount}
          updateProjectSampleSize = {this.props.updateProjectSampleSize}
          getAvModeratorsCount = {this.props.getAvModeratorsCount}
          openEditSampleSizeWarningModal={this.props.openEditSampleSizeWarningModal}
          isSubmitting={this.props.currentProject.isSubmitting}
          enableSubmit={this.props.editSampleSizeModal.enableSubmit}
          initialSampleSizeBeforeWarning={this.props.editSampleSizeModal.initialSampleSizeBeforeWarning}
          showWarningBanner={this.props.currentProject.showWarningBanner}
          t={this.props.t}
        />}

        {this.props.generateSchedulerLinkModal.isOpen && <GenerateSchedulerLinkModal
          isOpen={this.props.generateSchedulerLinkModal.isOpen}
          onClose={this.props.closeGenerateSchedulerLinkModal}
          onSubmit={() => this.props.openGenerateSchedulerLinkConfirmationModal({id: this.props.currentProject.id})}
          isSubmitting={this.props.currentProject.isSubmitting}
          topicNameDetails={this.props.currentProject.topicNameDetails}
          meetingInformationMap={this.props.currentProject.meetingInformationMap}
          t={this.props.t}
          displayError={this.props.currentProject.displayError}
          postScreeninBuffer={this.props.currentProject.postScreeninBuffer}
        />}

          {this.props.generateConfirmationSchedulerLinkModal.isOpen && <GenerateSchedulerLinkConfirmationModal
          chosenTranslationsLabels = {this.props.currentProject.chosenTranslationsLabels} 
          isOpen={this.props.generateConfirmationSchedulerLinkModal.isOpen}
          onClose={this.props.closeConfirmationGenerateSchedulerLinkModal}
          onSubmit={() => this.props.generateSchedulerLink({id: this.props.currentProject.id})}
          isSubmitting={this.props.currentProject.isSubmitting}
          topicNameDetails={this.props.currentProject.topicNameDetails}
          meetingInformationMap={this.props.currentProject.meetingInformationMap}
          t={this.props.t}
          displayError={this.props.currentProject.displayError}
          postScreeninBuffer={this.props.currentProject.postScreeninBuffer}
          conferenceLink={this.props.currentProject.conferenceLink}
        />}
        
        {this.props.editSurveyIdModal.isOpen && <EditSurveyIdModal
          isOpen={this.props.editSurveyIdModal.isOpen}
          onClose={this.props.closeEditSurveyIdModal}
          isSubmitting={this.props.currentProject.isSubmitting}
          t={this.props.t}
          openConfrimEditSurveyIdModal={this.props.openConfrimEditSurveyIdModal}
          currentProject={this.props.currentProject}
        />}

        {this.props.confirmEditSurveyIdModal.isOpen && <ConfirmEditSurveyIdModal
          isOpen={this.props.confirmEditSurveyIdModal.isOpen}
          onClose={this.props.closeConfirmEditSurveyIdModal}
          isSubmitting={this.props.currentProject.isSubmitting}
          props={this.props}
          t={this.props.t}
          currentProject={this.props.currentProject}
          editSurveyId={this.props.editSurveyId}
          editedSurveyId={this.props.confirmEditSurveyIdModal.editedsurveyId}
        />}

        {this.props.editSampleSizeWarningModal.isOpen && <EditSampleSizeWarningModal
          isOpen={this.props.editSampleSizeWarningModal.isOpen}
          onClose={this.props.closeEditSampleSizeWarningModal}
          isSubmitting={this.props.currentProject.isSubmitting}
          updateProjectSampleSize = {this.props.updateProjectSampleSize}
          t={this.props.t}
          projectId={this.props.currentProject.id}
          sampleSize={this.props.editSampleSizeWarningModal.sampleSize}
          initialSampleSize={this.props.editSampleSizeWarningModal.initialSampleSize}
          goBack={this.props.goBack}
        />} 

        {this.props.editInterviewOrModeratorBufferModal.isOpen && <EditInterviewOrModeratorBufferModal
          isOpen={this.props.editInterviewOrModeratorBufferModal.isOpen}
          onClose={this.props.closeEditInterviewOrModeratorBufferModal}
          isSubmitting={this.props.currentProject.interviewBufferIsSubmitting}
          t={this.props.t}
          currentProject={this.props.currentProject}
          onSubmit={this.props.editInterviewBuffer}
          flag= {this.props.flag}
          singleModerator={this.props.singleModerator}
        />}
      </div>
    )
  }
}

const mapState = state => ({
  surveysToLaunch: state.sidebar.surveysToLaunch,
  surveysToClose: state.sidebar.surveysToClose,
  pauseWarningOpen: state.currentProject.pauseWarningOpen,
  editWarningOpen: state.currentProject.editWarningOpen,
  completionsWarningOpen: state.currentProject.completionsWarningOpen,
  closeWarningOpen: state.sidebar.closeWarningOpen,
  media: state.currentProject.media,
  editSampleSizeModal: state.ui.editSampleSizeModal,
  generateSchedulerLinkModal : state.ui.generateSchedulerLinkModal,
  generateConfirmationSchedulerLinkModal : state.ui.generateConfirmationSchedulerLinkModal,
  editSurveyIdModal: state.ui.editSurveyIdModal,
  editInterviewOrModeratorBufferModal: state.ui.editInterviewOrModeratorBufferModal,
  confirmEditSurveyIdModal: state.ui.confirmEditSurveyIdModal,
  editSampleSizeWarningModal: state.ui.editSampleSizeWarningModal,
  previewConferenceLinkModal: state.ui.previewConferenceLinkModal,
  t: localizedTranslate('en', state.translations.en_us),
  exampleEmail: state.editSession.exampleEmail,
  isSubmitting: state.editSession.isSubmitting,
  templateReceived: state.editSession.templateReceived,
  projectList: state.projectList.byClientId,
  clientId: state.client.clientId,
  flag: state.ui.editInterviewOrModeratorBufferModal.flag,
  singleModerator: state.scheduler.singleModerator,
  userTimeZone: getUserTimeZone(state),
})

const mapDispatch = {
  handleTabChange: payload => ({ type: 'SCHEDULE_HANDLE_TAB_CHANGE', payload }),
  launchSurveys,
  closeSurveys,
  initLaunchSurveys: payload => ({ type: 'INIT_LAUNCH_SURVEYS_REQUESTED', payload }),
  initCloseSurveys: payload => ({ type: 'INIT_CLOSE_SURVEYS_REQUESTED', payload }),
  togglePauseWarning: () => ({ type: 'TOGGLE_PAUSE_WARNING_REQUESTED' }),
  toggleEditWarning: () => ({ type: 'TOGGLE_EDIT_WARNING_REQUESTED' }),
  toggleCompletionsWarning: () => ({ type: 'TOGGLE_COMPLETIONS_WARNING_REQUESTED' }),
  toggleCloseWarning: () => ({ type: 'TOGGLE_CLOSE_WARNING_REQUESTED' }),
  toggleUploadModal: () => ({ type: 'TOGGLE_UPLOAD_MODAL_REQUESTED' }),
  confirmFileUpload: () => ({ type: 'SHOW_MESSAGE', payload: {message: 'Your file has been uploaded successfully.'} }),
  fileUploadWarning: () => ({
    type: 'SHOW_MESSAGE', payload: {message: 'There was a problem while uploading your file, please try again.'},
  }),
  openEditSampleSizeModal: payload => ({ type: 'OPEN_EDIT_SAMPLE_SIZE_MODAL', payload }),
  openEditSurveyIdModal: () => ({ type: 'OPEN_EDIT_SURVEY_ID_MODAL'}),
  openEditInterviewOrModeratorBufferModal: payload => ({ type: 'OPEN_EDIT_INTERVIEW_OR_MODERATOR_BUFFER_MODAL', payload}),
  openConfrimEditSurveyIdModal: (payload) => ({ type: 'OPEN_CONFIRM_EDIT_SURVEY_ID_MODAL',payload}),
  closeGenerateSchedulerLinkModal: payload => ({ type: 'CLOSE_GENERATE_SCHEDULER_LINK_MODAL', payload }),
  closeConfirmationGenerateSchedulerLinkModal: payload => ({ type: 'CLOSE_CONFIRMATION_GENERATE_SCHEDULER_LINK_MODAL', payload }),
  openGenerateSchedulerLinkConfirmationModal: payload => ({ type: 'OPEN_SCHEDULER_LINK_CONFIRMATION_MODAL', payload }),
  closeEditSurveyIdModal: () => ({ type: 'CLOSE_EDIT_SURVEY_ID_MODAL' }),
  closeConfirmEditSurveyIdModal: () => ({ type: 'CLOSE_CONFIRM_EDIT_SURVEY_ID_MODAL' }),
  openEditSampleSizeWarningModal: payload => ({ type: 'OPEN_EDIT_SAMPLE_SIZE_WARNING_MODAL', payload }),
  closeEditSampleSizeWarningModal: () => ({ type: 'CLOSE_EDIT_SAMPLE_SIZE_WARNING_MODAL' }),
  closeEditInterviewOrModeratorBufferModal: () => ({ type: 'CLOSE_EDIT_INTERVIEW_OR_MODERATOR_BUFFER_MODAL'}),
  generateSchedulerLink,
  closeEditSampleSizeModal: () => ({ type: 'CLOSE_EDIT_SAMPLE_SIZE_MODAL' }),
  editSampleSizeSucceeded: payload => ({ type: 'EDIT_SAMPLE_SIZE_SUCCEEDED', payload }),
  goBack: payload => ({ type: 'EDIT_SAMPLE_SIZE_WARNING_GO_BACK' ,payload}),
  updateProjectSampleSize,
  getAvModeratorsCount,
  fetchProjectSurveys,
  editSurveyId,
  showSnackbarMessage: message => ({
    type: 'SHOW_MESSAGE',
    payload: {
      message: message,
      className: 'copy-screeners-snackbar',
    },
  }),
  hideSnackbarMessage: () => ({type:'HIDE_MESSAGE'}),
  editInterviewBuffer,
  showSnackbarMessageError: message => ({
    type: 'SHOW_MESSAGE',
    payload: {
      message: message,
    },
  }),
  getEmailTemplate,
  closeTemplate: payload => ({ type: 'CLOSE_TEMPLATE' ,payload}),
  setFilterdProjects :  payload => ({ type: 'SET_FILTERED_PROJECTS' ,payload}),
  setChosenTranslationsLabels : payload => ({type : 'SET_CHOSEN_TRANLSATIONS_LABELS', payload})
}

export default connect(mapState, mapDispatch)(Dashboard)
